import { render, staticRenderFns } from "./PaymentCreate.vue?vue&type=template&id=7a6fe357&"
import script from "./PaymentCreate.vue?vue&type=script&lang=js&"
export * from "./PaymentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VForm,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a6fe357')) {
      api.createRecord('7a6fe357', component.options)
    } else {
      api.reload('7a6fe357', component.options)
    }
    module.hot.accept("./PaymentCreate.vue?vue&type=template&id=7a6fe357&", function () {
      api.rerender('7a6fe357', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Payment/components/PaymentGateway/PaymentCreate.vue"
export default component.exports